import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { getCompanyName } from 'modules/profile/selectors'
import { getUniqueHandle } from 'modules/org/selectors'
import { updateEmbed, updateOrg, checkUniqueHandle } from 'modules/org/actions'
import { toLower, replace } from 'ramda'

import OnboardingCompanyInfo from 'layouts/OnboardingCompanyInfo'

export const getDefaultDirectoryUrl = (state) => {
  const companyName = getCompanyName(state)
  return !!companyName ? toLower(replace(/\s/g, '-', companyName)) : ''
}

const mapStateToProps = (state) => {
  return {
    companyName: getCompanyName(state),
    uniqueHandle: getUniqueHandle(state),
    directoryUrl: getDefaultDirectoryUrl(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateEmbed,
    updateOrg,
    checkUniqueHandle
  }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingCompanyInfo)


// WEBPACK FOOTER //
// ./src/containers/OnboardingCompanyInfo/index.js